import { makeAutoObservable } from "mobx";
import { enableStaticRendering } from "mobx-react";

const isServer = typeof window === "undefined";
enableStaticRendering(isServer);

const normalizePopups = (popups = []) => {
  // Ensure popups is an array (defensive check)
  // Prevents .map() errors when data is malformed or during 404/500 prerender
  if (!Array.isArray(popups)) {
    return [];
  }
  return popups.map((popup) => {
    return {
      id: popup.id,
      ...popup.attributes,
    };
  });
};

class PopupStore {
  popupsData = [];

  constructor(initialData) {
    makeAutoObservable(this);
    // Ensure initialData is an array before normalizing
    // Handle both empty initialData (404/500 pages) and malformed data
    if (initialData && Array.isArray(initialData)) {
      this.popupsData.replace(normalizePopups(initialData));
    }
  }

  get allPopups() {
    return this.popupsData;
  }
}

export default PopupStore;
